'use client';

import { useI18n } from 'next-localization';

import { Controller, useFormContext } from 'react-hook-form';

import { LocationInput } from '@/components/location-input/location-input';
import { TypeaheadSelectable } from '@/components/typeahead/typeahead-new.types';
import { AZ_REQUEST_PARAMS } from '@/lib/constants';
import { cn } from '@/lib/utils';
import { AddressRequest } from '@xsf/shared-lib/hooks/location';

import styles from '../../listing.module.css';

export const LocationFilter = ({ removePadding }: { removePadding?: boolean }): JSX.Element => {
  const { t } = useI18n();

  const { control } = useFormContext();

  // test if the input is probably a zip code
  // const userTypingZip = useMemo(() => /^[0-9]+(-[0-9]*)?$/.test(typeaheadQuery), [typeaheadQuery]);

  return (
    <div
      className={cn(
        {
          ['p-1']: !removePadding,
        },
        styles.useMyLocation
      )}
    >
      <Controller
        name="zip"
        control={control}
        render={({ field }) => {
          return (
            <LocationInput
              containerClassName={styles.locationInputContainer}
              azRequestParams={AZ_REQUEST_PARAMS as Omit<AddressRequest, 'query'>}
              autoSelectOnBlur
              autofillQueryParam="zip"
              id="use-my-location-input"
              label={t('Locations.Search.Form.EnterLocationLabel')}
              placeholder={t('OAS.LandingPage.CityOrZipCode')}
              onSelectItem={(item: TypeaheadSelectable) => {
                if (!item?.data) {
                  return;
                }

                if (typeof window === 'undefined') {
                  return;
                }

                sessionStorage.setItem('selectedLocation', JSON.stringify(item.data));
              }}
              typeaheadValidationRules={[
                {
                  regex: /^[a-zA-Z0-9()-–',.&\s]+$/,
                  message: t('Search.Errors.InvalidSpecialCharacters'),
                },
                // add one for cyrilic characters
                {
                  regex: /^[^\u0400-\u04FF]+$/,
                  message: t('Search.Errors.InvalidSpecialCharacters'),
                },
              ]}
              {...field}
            />
          );
        }}
      />
    </div>
  );
};
